import { FC } from 'react';
import { Agent } from 'src/types/agents.ts';

interface DexToolsChartProps {
  agent: Agent;
}

export const DexToolsChart: FC<DexToolsChartProps> = ({ agent }) => {
  return (
    <iframe
      id="dextools-widget"
      title="DEXTools Trading Chart"
      width="500"
      height="400"
      src={`https://www.dextools.io/widget-chart/en/base/pe-light/${agent.token_info.uniswap_pair_address}?theme=dark&chartType=2&chartResolution=30&drawingToolbars=false`}
    />
  );
};
